import React, {Fragment} from 'react';
import {Flex, Breadcrumbs, Layout, Button, Form, Textarea, List} from 'components';
import {useSelector} from "vendor";
import {store} from "store";
import {moment, redirect, useNamedSelector} from "helpers";

export function Reflections() {

  const { firstDayOfWeek } = useNamedSelector('settings.settings');

  moment.updateLocale('en', {
    week: {
      dow: firstDayOfWeek - 1 // 1 = Sunday, 2 = Monday
    }
  });
  const startOfWeek = moment().startOf('week');
  const endOfWeek = moment().endOf('week');

  const questions = useSelector((state) => {
      return Object.values(state.questions).filter(q => q.type === 'weekly_reflections');
    }
  );

  const isWithinCurrentWeek = (date) => {
    const questionDate = moment(date, 'MM/DD/YYYY');
    return questionDate.isBetween(startOfWeek, endOfWeek, 'day', '[]');
  };

  const getAnswer = (key) => {
    const question = questions.find(q => q.key === key) || null;
    return question && question.date && isWithinCurrentWeek(question.date)
      ? question.value
      : '';
  };

  const initialValues = {
    reflection_10: getAnswer('10'),
    reflection_20: getAnswer('20'),
    reflection_30: getAnswer('30'),
    reflection_40: getAnswer('40'),
    reflection_50: getAnswer('50'),
    reflection_60: getAnswer('60'),
  }

  const saveAndContinue = (form) => {
    const date = moment(endOfWeek).format('MM/DD/YYYY');
    ['10', '20', '30', '40', '50', '60'].forEach((key) => {
      const value = form[`reflection_${key}`];
      const question = questions.find(q => q.key === key);
      const id = question.id;
      store.dispatch({
        type: 'QUESTION_VALUE_UPDATE',
        id,
        value,
        date,
      });
    });
    redirect(`/today/`, true);
  };

  return (
    <Form initialValues={initialValues} onSubmit={saveAndContinue} delay>
      <Layout.Header>
        <Flex>
          <div className="pull-left">
            <Breadcrumbs>
              <b>Weekly Reflections</b>
            </Breadcrumbs>
          </div>
          <Button to="/today/plan-my-week/activities" className={['small', 'borderless']} icon="return">
            Back
          </Button>
          <Button className={['primary', 'small']} type="submit">Done</Button>
        </Flex>
      </Layout.Header>
      <div className="sticky-container">
        <List tiny-gutter>
          <Fragment>
            <Flex middle justified className="smedium-spacing">
              What's driving you?
            </Flex>
            <Textarea name="reflection_10" minRows={1}/>
          </Fragment>
          <Fragment>
            <Flex middle justified className="smedium-spacing">
              What's stopping you?
            </Flex>
            <Textarea name="reflection_20" minRows={1}/>
          </Fragment>
          <Fragment>
            <Flex middle justified className="smedium-spacing">
              What can you do differently this week?
            </Flex>
            <Textarea name="reflection_30" minRows={1}/>
          </Fragment>
          <Fragment>
            <Flex middle justified className="smedium-spacing">
              What should you spend less time on?
            </Flex>
            <Textarea name="reflection_40" minRows={1}/>
          </Fragment>
          <Fragment>
            <Flex middle justified className="smedium-spacing">
              What should you spend more time on?
            </Flex>
            <Textarea name="reflection_50" minRows={1}/>
          </Fragment>
          <Fragment>
            <Flex middle justified className="smedium-spacing">
              What would be your biggest challenge next week? How can you handle it?
            </Flex>
            <Textarea name="reflection_60" minRows={1}/>
          </Fragment>
        </List>
      </div>
    </Form>
  )
}
